const STORAGE_KEY = "ceLessonEditorPendingScroll";
const MAX_AGE_MS = 120000;

/**
 * Persists the intended #ce-… fragment when navigating from program/unit sidebar so the
 * lesson editor can scroll even if the client router drops or delays the hash.
 */
export const setPendingLessonEditorScroll = (lessonId, hashFragment) => {
  if (lessonId == null || hashFragment == null || hashFragment === "") return;
  const frag = String(hashFragment).replace(/^#/, "");
  if (!frag) return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        lessonId: String(lessonId),
        hashFragment: frag,
        ts: Date.now(),
      })
    );
  } catch (_) {
    /* ignore quota / private mode */
  }
};

/**
 * @returns {string | null} fragment without #, or null
 */
export const consumePendingLessonEditorScroll = (lessonId) => {
  if (lessonId == null) return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (String(p.lessonId) !== String(lessonId)) return null;
    if (Date.now() - (p.ts || 0) > MAX_AGE_MS) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    sessionStorage.removeItem(STORAGE_KEY);
    const frag = p.hashFragment ? String(p.hashFragment).replace(/^#/, "") : "";
    return frag || null;
  } catch {
    return null;
  }
};
